(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!window.collectionEditorialHandlersBound) {
    window.collectionEditorialHandlersBound = true;

    const closeCollectionEditorialDrawer = (drawer) => {
      if (!drawer) return;

      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('collection-editorial-drawer-open');

      const opener = document.querySelector(`[data-collection-mobile-drawer-open="${drawer.id}"]`);
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }

      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 240);
    };

    const closeAllCollectionEditorialDrawers = () => {
      document.querySelectorAll('[data-collection-mobile-drawer].is-open').forEach((drawer) => {
        closeCollectionEditorialDrawer(drawer);
      });
    };

    const closeCollectionEditorialSortDropdown = (dropdown) => {
      if (!dropdown) return;

      dropdown.classList.remove('is-open');
      dropdown.setAttribute('aria-hidden', 'true');

      const opener = document.querySelector(`[data-collection-mobile-sort-toggle="${dropdown.id}"]`);
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }
    };

    const closeAllCollectionEditorialSortDropdowns = () => {
      document.querySelectorAll('[data-collection-mobile-sort-dropdown].is-open').forEach((dropdown) => {
        closeCollectionEditorialSortDropdown(dropdown);
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const drawerOpenButton = target.closest('[data-collection-mobile-drawer-open]');
      if (drawerOpenButton) {
        const drawerId = drawerOpenButton.getAttribute('data-collection-mobile-drawer-open');
        const drawer = drawerId ? document.getElementById(drawerId) : null;
        if (!drawer) return;

        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();
        drawer.hidden = false;
        drawerOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('collection-editorial-drawer-open');
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
        });

        const panel = drawer.querySelector('.collection-editorial-mobile-drawer__panel');
        if (panel) {
          panel.focus({ preventScroll: true });
        }

        return;
      }

      const drawerCloseButton = target.closest('[data-collection-mobile-drawer-close]');
      if (drawerCloseButton) {
        closeCollectionEditorialDrawer(drawerCloseButton.closest('[data-collection-mobile-drawer]'));
        return;
      }

      const sortToggleButton = target.closest('[data-collection-mobile-sort-toggle]');
      if (sortToggleButton) {
        const dropdownId = sortToggleButton.getAttribute('data-collection-mobile-sort-toggle');
        const dropdown = dropdownId ? document.getElementById(dropdownId) : null;
        if (!dropdown) return;

        const willOpen = !dropdown.classList.contains('is-open');
        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();

        if (willOpen) {
          dropdown.classList.add('is-open');
          dropdown.setAttribute('aria-hidden', 'false');
          sortToggleButton.setAttribute('aria-expanded', 'true');
        }

        return;
      }

      if (!target.closest('.collection-editorial-toolbar')) {
        closeAllCollectionEditorialSortDropdowns();
      }

      const button = target.closest('[data-grid-view-value]');
      if (!button) return;

      const section = button.closest('[data-collection-editorial]');
      if (!section) return;

      const value = button.getAttribute('data-grid-view-value') || 'default';
      section.setAttribute('data-grid-view', value);

      section.querySelectorAll('[data-grid-view-value]').forEach((control) => {
        control.classList.toggle('is-active', control === button);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-collection-mobile-drawer]').forEach((drawer) => {
        closeCollectionEditorialDrawer(drawer);
      });
      event.target.querySelectorAll('[data-collection-mobile-sort-dropdown]').forEach((dropdown) => {
        closeCollectionEditorialSortDropdown(dropdown);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
